import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../../helpers/reselectHelpers';
import {
  IntegrationSettingsTypesEnum,
  SalesforceIntegrationModel,
} from '../../../../../../models/api/integrationModel';
import {AppState} from '../../../../../../store/appState';
import {
  signInToIntegrationAccountAction,
  signOutOfIntegrationAsyncAction,
} from '../../../../../../store/data/integrations/integrationsActions';
import {SettingsAppsConfigureSalesforce} from './settingsAppsConfigureSalesforce';

/*
 * Props.
 */

interface SettingsAppsConfigureSalesforceContainerProps {
  integration?: SalesforceIntegrationModel;
}

/*
 * Selectors.
 */

function getIntegration(_state: AppState, props: SettingsAppsConfigureSalesforceContainerProps) {
  return props.integration;
}

function makeGetSalesforceUsername() {
  return createSelector([getIntegration], (integration) => {
    if (!integration) {
      return undefined;
    }
    return integration.settings.readonly?.user?.name;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  username: makeGetSalesforceUsername(),
}));

const mapDispatchToProps = makeMapDispatchToProps<SettingsAppsConfigureSalesforceContainerProps>()(
  ({integration}) => ({
    onSignOut: () => signOutOfIntegrationAsyncAction(IntegrationSettingsTypesEnum.SALESFORCE),
    onSignIn: (shouldUseTestEnv: boolean) =>
      signInToIntegrationAccountAction(
        IntegrationSettingsTypesEnum.SALESFORCE,
        integration?.name || 'Salesforce',
        shouldUseTestEnv,
      ),
  }),
);

export const SettingsAppsConfigureSalesforceContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsAppsConfigureSalesforce);
